import React from 'react';

import warning_icon from '../../../assets/icons/WarningCircle.svg';

import { t } from 'i18next';

function TagInput({
    value,
    onChange,
    onAddTag,
    onRemoveTag,
    tags,
    isSubmitted,
    isRequired,
    errorText,
    placeholder
}) {
    const hasError = isRequired && isSubmitted && tags.length === 0;
    const isInputEmpty = value.trim() === '';

    return (
        <div className="flex flex-col">
            <div className="input_header">
                <label className="text_input_label">{t('keywords')}</label>
            </div>

            <div className="input_header">
                {isRequired && isSubmitted && hasError && (
                    <span className="error_text">{errorText}</span>
                )}

                {isRequired && isSubmitted && hasError && (
                    <img src={warning_icon} alt={t('warning')} />
                )}
            </div>

            <div className="flex flex-col sm:flex-row items-stretch gap-2 text_input_box">
                <input
                    className={`phone_input flex-1 min-w-0 ${hasError ? 'border-red-500' : ''}`}
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
                <button
                    type="button"
                    className={`h-[40px] px-4 rounded-[10px] text-base flex items-center justify-center border-none transition-colors ${
                        isInputEmpty
                            ? 'bg-[#939393] text-white cursor-not-allowed opacity-70'
                            : 'bg-[var(--primary-color)] text-white hover:bg-[var(--hover-color)] cursor-pointer'
                    }`}
                    onClick={onAddTag}
                    disabled={isInputEmpty}
                >
                    {t('add')}
                </button>
            </div>

            <div className="flex flex-wrap gap-2 mt-2">
                {tags.map((tag, index) => (
                    <div
                        className="inline-flex items-center bg-[var(--primary-color)] text-white px-3 py-1 rounded-[10px] text-sm"
                        key={index}
                    >
                        <span>{tag}</span>
                        <button
                            type="button"
                            className="ml-2 bg-transparent border-none text-white text-xs cursor-pointer hover:text-[#dc3545]"
                            onClick={() => onRemoveTag(index)}
                        >
                            ✕
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TagInput;